import { createSlice } from "@reduxjs/toolkit";
import axiosGeneral from "helpers/axios/axiosGeneral";
import { cleanEffice } from "helpers/efficeHelpers";
import { FM_CENTRALEFFICES, unsetFreshmanWatched } from "helpers/freshman";
import {
  getCurrentToken,
  selectCurrentUserAttributes,
  signMeOut,
} from "./authSlice";
import { addSingleData } from "./efficeCacheSlice";
import { addToCurrentTree, goToEffice } from "./efficeTreeSlice";
import { setGeneralModal } from "./generalSlice";
let dispatch = null;
let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  getState = module.store.getState;
});

const initialState = {
  inviteCode: null,
  inviteEffice: null,
};

export const slice = createSlice({
  name: "join",
  initialState,
  reducers: {
    setInviteCode: (state, action) => {
      state.inviteCode = action.payload;
    },
    setInviteEffice: (state, action) => {
      state.inviteEffice = action.payload;
    },
    resetJoinSlice: () => initialState,
  },
});

export const getInviteAvailability = (invite_code) => {
  return new Promise((res, rej) => {
    axiosGeneral
      .get(`/join/${invite_code}`, {})
      .then((response) => {
        window.efs_debug &&
          window.log("Successfully retrieved invite_code availability");
        window.efs_debug && window.log(response);
        let cleanedEffice = cleanEffice(response.data.effice);
        dispatch(setInviteCode(invite_code));
        dispatch(setInviteEffice(cleanedEffice));
        res(cleanedEffice.id);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          dispatch(setInviteCode(null));
          dispatch(setInviteEffice(null));
        } else {
          window.efs_debug && window.log("Failed to retrieve invite_code");
          window.efs_debug && window.log(error);
          dispatch(
            setGeneralModal({
              title: "Error",
              content: "Could not verify the invite link, try again later.",
            })
          );
        }
        rej(error);
      });
  });
};

// User needs to be signed in before entering this
export const tryEnterNewRoot = (inviteCode) =>
  new Promise((res, rej) => {
    if (!inviteCode || !selectCurrentUserAttributes(getState())) {
      rej();
      return;
    }
    getCurrentToken().then((idToken) => {
      axiosGeneral
        .post(`/join/${inviteCode}`, null, {
          headers: {
            Authorization: "Bearer " + idToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          window.efs_debug &&
            window.log("Successfully joined or rejoined effice");
          window.efs_debug && window.log(response);
          // To prevent a race condition in case the response comes before the websocket
          let newEffice = cleanEffice(response.data.effice);
          dispatch(addSingleData(newEffice));
          dispatch(addToCurrentTree({ location: [], id: newEffice.id }));
          goToEffice(newEffice.id);
          res();
        })
        .catch((error) => {
          window.efs_debug && window.log("Failed to join root");
          window.efs_debug && window.log(error);
          let message = error.response?.data?.errors?.detail
            ? error.response.data.errors.detail
            : "";
          if (message === "already a member") {
            message = "You are already a member of this effice.";
            unsetFreshmanWatched(FM_CENTRALEFFICES);
            res();
          } else {
            rej(error);
            dispatch(
              setGeneralModal({
                title: "Error",
                content: (
                  <>
                    Could not enter this effice.
                    <br />
                    <br />
                    {`${message}`}
                    <br />
                  </>
                ),
              })
            );
          }
        });
    });
  });

export const tryUseAnotherAccount = () => (dispatch, getState) => {
  let inviteCode = getState().join.inviteCode;
  let inviteEffice = getState().join.inviteEffice;
  signMeOut();
  dispatch(setInviteCode(inviteCode));
  dispatch(setInviteEffice(inviteEffice));
};

export const { setInviteCode, setInviteEffice, resetJoinSlice } = slice.actions;

export const selectInviteCode = (state) => state.join.inviteCode;
export const selectInviteEffice = (state) => state.join.inviteEffice;

export default slice.reducer;
